import { restaurantCapabilitiesApiRoot } from '../../config.{env}.json'
import actionTypes     from '../actionTypes';
import * as superagent from 'superagent';

export function getRestaurantDetails() {
    return (dispatch, getState) => {
        const token = getState().oidc.user.access_token;
        const tenant = getState().tenant.currentTenant;
        const restaurantId = getState().restaurant.restaurantId;

        dispatch({
            type: actionTypes.RESTAURANT_DETAILS_LOADING
        });

        superagent
            .get(`${restaurantCapabilitiesApiRoot}/${tenant}/restaurants/${restaurantId}/details`)
           // .set('Authorization', `Bearer ${token}`)
            .then(res => dispatch({
                type: actionTypes.RESTAURANT_DETAILS_LOADED,
                payload: res.body.Details[0]
            }))
            .catch(error => dispatch({
                type: actionTypes.RESTAURANT_DETAILS_ERROR
            }));
    }
}



export function setCurrentRestaurant(id) {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_RESTAURANT_ID,
            payload: id
        });
    }
}



// WEBPACK FOOTER //
// /src/store/actions/restaurant.js